import { legalConfig as cfg } from '../legalConfig';
import { LegalDoc } from '../types';

export const communityGuidelinesDoc: LegalDoc = {
  slug: 'community-guidelines',
  title: 'Community Guidelines',
  effectiveDate: cfg.effectiveDate,
  lastUpdated: cfg.lastUpdated,
  intro: [
    `${cfg.brandName} should feel useful, respectful, and safe. These Guidelines apply to profiles, listings, chats, photographs, meetings arranged through ${cfg.brandName}, landlord conversations, and support interactions.`,
  ],
  sections: [
    {
      heading: 'Be genuine',
      blocks: [
        {
          type: 'p',
          text: 'Use your real details, current photographs, honest housing needs, and accurate property information. Do not impersonate anyone or misrepresent authority to list a property.',
        },
      ],
    },
    {
      heading: 'Respect boundaries',
      blocks: [
        {
          type: 'p',
          text: 'Do not harass, threaten, stalk, pressure, shame, or send unwanted sexual content. A match or reply does not create an obligation to meet, share contact details, pay money, sign a lease, or continue communicating.',
        },
      ],
    },
    {
      heading: 'Follow fair housing and equality rules',
      blocks: [
        {
          type: 'p',
          text: 'Do not publish discriminatory listings or apply unlawful criteria. Roommate compatibility questions must be relevant, respectful, and lawful. Landlords and representatives must not unfairly discriminate in advertising, screening, negotiation, or leasing.',
        },
      ],
    },
    {
      heading: 'Protect privacy',
      blocks: [
        {
          type: 'p',
          text: "Do not share someone else's chats, photographs, contact details, identity documents, financial information, or location without permission. Never pressure another person to disclose sensitive information.",
        },
      ],
    },
    {
      heading: 'Keep housing and payments safe',
      blocks: [
        {
          type: 'p',
          text: `Verify the property and the person authorised to let it. View the property safely, read the lease, confirm deposit arrangements, and keep payment records. Do not use ${cfg.brandName} for fake listings, advance-fee scams, unlawful deposits, or deceptive payment requests.`,
        },
      ],
    },
    {
      heading: 'No harmful or illegal activity',
      blocks: [
        {
          type: 'p',
          text: `${cfg.brandName} does not permit hate speech, exploitation, trafficking, fraud, malware, illegal goods or services, violent threats, or content that facilitates serious harm.`,
        },
      ],
    },
    {
      heading: 'Report concerns',
      blocks: [
        {
          type: 'p',
          text: `Use the report and block tools or contact ${cfg.supportEmail}. For immediate danger, contact emergency services. ${cfg.brandName} may remove content or restrict accounts while investigating.`,
        },
      ],
    },
    {
      heading: 'Enforcement',
      blocks: [
        {
          type: 'p',
          text: `${cfg.brandName} may consider context, severity, history, and available evidence. Possible action includes a warning, content removal, feature restriction, account suspension, permanent removal, preservation of evidence, or referral to appropriate authorities. Where safe and appropriate, users may request a review by contacting ${cfg.supportEmail}.`,
        },
      ],
    },
  ],
};
